// extracted by mini-css-extract-plugin
export default {"content":"CasesPage_content__8ya1J","cases":"CasesPage_cases__cmxiG"};